import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as core from 'hub-http/middlewares/core';
import * as hubapi from 'hub-http/middlewares/hubapi';
// @ts-expect-error untyped module
import * as debug from 'hub-http/middlewares/debug';
// @ts-expect-error untyped module
import * as externalAuth from 'hub-http/middlewares/externalAuth';
// @ts-expect-error untyped module
import { allowMissingPortalId } from 'hub-http/middlewares/cookieAuth';
// @ts-expect-error untyped module
import * as user from 'hub-http/middlewares/user';

/**
 * A client for hubless login-verify requests with proper logout behavior.
 *
 * Based on noPortalApiClient (allowMissingPortalId + hubapi stack) with
 * swapped logout/retry middlewares to match loginVerifyClient behavior.
 */
const hublessLoginVerifyStack = createStack(allowMissingPortalId, core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly, hubapi.hubapi, externalAuth.cookieAuthentication, core.withQuery, debug.rewriteUrl, debug.enableFailureInjection, hubapi.timeoutInQuery, hubapi.setRequest, core.reportOptionsError,
// hubapi uses hubapi.logoutOnUnauthorized (only 401 with x-hubspot-auth-failure header)
// we use this instead to logout on 401 OR 403
user.logoutOnUnauthorizedOrForbidden, core.enableMigrationCheckBypass, core.redirectOnMigrationInProgress, core.redirectOnPortalMoved,
// hubapi uses hubapi.retryOnError (no logout after max retries)
// we use this instead to logout after max retries
user.retryOnError, core.validateStatus, core.jsonResponse);
export default promiseClient(hublessLoginVerifyStack);